import "./css/noticias.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Tecnologia from "../../images/home/marca/innovacion/hyundai-innovacion-tecnologia.webp";
import Seguridad from "../../images/home/marca/innovacion/hyundai-innovacion-seguridad.webp";
import Disenio from "../../images/home/marca/innovacion/hyundai-innovacion-disenio.webp";

function InfoInnovacion() {
  return (
    <Container>
      <Row>
        <Col md={12} className="mt-4 mt-md-5 pt-md-4 mb-2 pl-3 pl-md-0">
          <h1 className="home-titulo-innovacion">Innovación.</h1>
        </Col>
      </Row>
      <Row>
        <Col md={7} className="px-0">
          <Image src={Tecnologia} width="665" height="396" alt="Hyundai Tecnología" title="Hyundai Tecnología" fluid />
        </Col>
        <Col md={5} className="bg-brown px-0">
          <h2 className="home-titulo-innovacion mt-4 px-4">Tecnología.</h2>
          <p className="home-texto-innovacion px-4">
            Vehículos más fuertes y ligeros es la evolución que Hyundai obtiene para mayor seguridad y estilo.
          </p>
          <p className="home-texto-innovacion px-4">
            Mejor rendimiento, mayor eficiencia y emisiones más limpias.
          </p>
          <p className="home-texto-innovacion px-4">
            La era de los automóviles inteligentes se acerca rápidamente a medida que los automóviles aprovechan cada vez más los desarrollos de tecnología electrónica.
          </p>
          <p className="home-texto-innovacion px-4">
            Ya hay automóviles por ahí que pueden conducir ellos mismos, ajustar automáticamente la velocidad y maniobrar en el arcén en situaciones de emergencia.
          </p>
        </Col>
      </Row>
      <Row className="mt-4 mt-md-5">
        <Col md={5} className="bg-blue px-0 order-2 order-md-1">
          <h2 className="home-titulo-innovacion mt-4 text-light px-4">
            Seguridad.
          </h2>
          <p className="home-texto-innovacion text-light px-4">
            Hyundai se está centrando en tecnologías que se puede aplicar a la mayor cantidad de autos de pasajeros posible.
          </p>
          <p className="home-texto-innovacion text-light px-4">
            Si bien tiene un esfuerzo constante en la seguridad del automóvil, Hyundai impulsa la adopción de nuevas tecnologías.
          </p>
          <p className="home-texto-innovacion text-light px-4">
            Hyundai te brinda la forma más segura de revolucionar tu vida diaria al hacer vehículos para una movilidad sin barreras.
          </p>
        </Col>
        <Col md={7} className="px-0 order-1 order-md-2">
          <Image src={Seguridad} width="672" height="396" alt="Hyundai Innovación" title="Hyundai Innovación" fluid />
        </Col>
      </Row>
      <Row className="my-4 my-md-5">
        <Col md={7} className="px-0">
          <Image src={Disenio} width="665" height="396" alt="Hyundai Diseño" title="Hyundai Diseño" fluid />
        </Col>
        <Col md={5} className="bg-blue px-0">
          <h2 className="home-titulo-innovacion mt-4 text-light px-4">
            Diseño.
          </h2>
          <p className="home-texto-innovacion text-light px-4">
            Los innovadores diseños de vehículos de Hyundai Motor se basan en un principio llamado "Deportividad sensual".
          </p>
          <p className="home-texto-innovacion text-light px-4">
            Al asegurarnos de maximizar los valores emocionales de las personas en armonía con un sentido riguroso de proporción, estructura, estilo y tecnología, producimos autos que cumplen y generalmente superan, incluso las elecciones estéticas más exigentes de nuestros clientes.
          </p>
        </Col>
      </Row>
    </Container>
  );
}
export default InfoInnovacion;